module.exports = __webpack_public_path__ + "img/hot-badge.5b152e17.svg";